<script setup lang="ts">

defineProps({
  title: {
    type: String
  },
  value: {
    type: String
  }
});
</script>

<template>
    <div class="cell-root">
        <h3 class="title">{{ title }}</h3>
        <h3 class="value">{{ value }}</h3>
    </div>
</template>

<style scoped lang="scss">
.cell-root {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.title {
  width: 100%;
  word-wrap: break-word;
  overflow-wrap: break-word;
  white-space: normal; 
}
.value {
    font-weight: 700;
}
</style>
